import * as React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled, { css } from "styled-components";

const sum = (total, current) => total + current.value;

const BaseTotalStyles = css`
    font-weight: bold;
    white-space: nowrap;
    padding-left: 10px;
`;

const InvalidTotal = styled.span`
    ${BaseTotalStyles}
    color: red;
`;

const Total = styled.span`
    ${BaseTotalStyles}
    color: limegreen;
`;


const RockValue = ({ elements }) => {
    let value = elements.reduce(sum, 0);
    if (Number.isNaN(value))
        return (<InvalidTotal>0.00</InvalidTotal>);

    value = Number.parseFloat(value).toFixed(2);
    return (<Total>{value}</Total>);
};

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(RockValue));